/**
 * Onboarding helpers.
 *
 * Completion state is stored server-side on `organizations.onboarding_completed_at`.
 * The frontend reads this via apiClient.getTeamMembers() → organization.onboardingCompletedAt.
 *
 * The only step-progress state (which step you're on) is stored in sessionStorage
 * so it survives page refreshes within the same browser session but resets on new sessions.
 */

const KEY_STEP = "shippeek_onboarding_step";

export function getOnboardingStep(): number {
  const raw = sessionStorage.getItem(KEY_STEP);
  if (raw === null) return 0;
  const n = parseInt(raw, 10);
  return Number.isFinite(n) ? n : 0;
}

export function setOnboardingStep(n: number): void {
  sessionStorage.setItem(KEY_STEP, String(n));
}
